import React, { FC, useEffect, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Sizes } from "src/@types/sizes";
import { getContactsAsync } from "src/redux/contactUs/actions";
import { selectContactUsState } from "src/redux/contactUs/selectors";
import { BreadCrumbs } from "src/components/BreadCrumbs";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { Loader } from "src/components/Loader";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { CONTACT_US_BREADCRUMBS_ITEMS } from "src/page-components/contact-us/constants/breadcrumbs";
import { getContactItems } from "src/page-components/contact-us/constants/contact-items";
import { ContactUsForm } from "src/page-components/contact-us/ContactUsForm";
import {
  contactUsTrns,
  ourContactsTrns,
} from "src/page-components/contact-us/trns";
import { MetadataWrapper } from "src/components/MetadataWrapper";

const ContactUs: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { isLoadingContacts, contacts } = useAppSelector(selectContactUsState);

  const contactsList = useMemo(() => getContactItems(contacts), [contacts]);

  useEffect(() => {
    dispatch(getContactsAsync());
  }, [dispatch]);

  return (
    <MetadataWrapper name="contact_us">
      <PageWrapper mainClassName="flex flex-col mt-19">
        <div className="container my-10">
          <BreadCrumbs
            items={CONTACT_US_BREADCRUMBS_ITEMS}
            className="hidden gl:block"
          />
          <h1 className="text-28 text-purple-base font-semibold my-10">
            {t(contactUsTrns.contactUsTitle)}
          </h1>
          <div className="flex  flex-col lg:flex-row gap-10">
            <ContactUsForm />

            <div className="lg:max-w-100 w-full">
              <h2 className="text-xl mb-10 text-purple-base font-semibold">
                {t(ourContactsTrns.ourContactsTitle)}
              </h2>
              <ul className="flex flex-col gap-10 text-lg text-purple-base">
                {isLoadingContacts ? (
                  <Loader size={Sizes.M} />
                ) : (
                  contactsList?.map(({ i18nKey, i18nParams }) => (
                    <li key={i18nKey}>
                      <Trans
                        i18nKey={i18nKey}
                        values={i18nParams}
                        components={{ br: <br /> }}
                      />
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </div>
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default ContactUs;
